import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, select, Store} from '@ngrx/store';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import * as actionsUi from './funkprotokollierung.actions.ui';
import {PageState} from './funkprotokollierung.reducer';
import {GetFunkprotokollAction, GetFunkprotokollMeldeartListeAction, GetFunkprotokollVorlagenListeAction, PostFunkprotokollEintragEntfernenAction, PostFunkprotokollEintragErfassenAction, PostFunkprotokollFallAbschliessenAction, PostFunkprotokollFallEntfernenAction, PostFunkprotokollFallErfassenAction, PostFunkprotokollFallReaktivierenAction} from '../../../client-ngrx/veranstaltungen';
import {getAktuellerProtokollEintrag, getAktuellerProtokollFall} from './funkprotokollierung.selectors';
import {FunkprotokollFallRequest} from '../../../clients/veranstaltungen';
import {FunkprotokollEintragRequest} from '../../../clients/veranstaltungen';
import {UuidService} from '@orga-app/providers/uuid.service';
import {GetIncidentByFunkprotokollFallAction, PostIncidentAnlegenAusFunkprotokollAction} from '../../../client-ngrx/incidents';
import {IncidentFunkprotokollRequest} from '../../../clients/incidents';
import {getAusgewaehlteVeranstaltung} from '../app-state/app-state.reducer';
import {AKTUELLE_VERANSTALTUNG_SETZEN, AktuelleVeranstaltungSetzenAction} from '../app-state/actions/veranstaltung.actions';
import {getZugriffVeranstaltungen} from '../../navi/navi.reducer';

@Injectable()
export class FunkprotokollierungPageUiEffects {

    @Effect()
    pageReset$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET)
        , withLatestFrom(this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([, aktuelleVeranstaltung]) => aktuelleVeranstaltung !== null)
        , flatMap(([x, aktuelleVeranstaltung]) =>
            [new GetFunkprotokollAction(aktuelleVeranstaltung.veranstaltung_id),
            new GetFunkprotokollMeldeartListeAction(),
            new GetFunkprotokollVorlagenListeAction()]
        )
    );

    @Effect()
    aktuelleVeranstaltungSetzen$: Observable<Action> = this.actions$.pipe(
        ofType(AKTUELLE_VERANSTALTUNG_SETZEN),
        map((x: AktuelleVeranstaltungSetzenAction) => x),
        filter(x => x.payload != null),
        map(x => x.payload),
        filter(x => x.veranstaltung_id != null),
        withLatestFrom(this.store.pipe(select(getZugriffVeranstaltungen))),
        filter(([x, zugriff]) => zugriff.ist_funkprotokoll_benutzer),
        flatMap(([x, zugriff]) =>
            [new GetFunkprotokollAction(x.veranstaltung_id),
                new GetFunkprotokollMeldeartListeAction(),
                new GetFunkprotokollVorlagenListeAction()]
        )
    );

    @Effect()
    protokollFallEntfernen$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PROTOKOLL_FALL_ENTFERNEN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollFall)), this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => aktuellerProtokollFall !== null && aktuellerProtokollFall !== undefined
            && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined)
        , map(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => {
            const request: FunkprotokollFallRequest = {
                fall_id: aktuellerProtokollFall.fall_id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
            };
            return new PostFunkprotokollFallEntfernenAction(request);
        })
    );

   @Effect()
    protokollEintragEntfernen$: Observable<Action> = this.actions$.pipe(
        ofType(actionsUi.PROTOKOLL_EINTRAG_ENTFERNEN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollEintrag)), this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokolleintrag, aktuelleVeranstaltung]) => aktuellerProtokolleintrag !== null && aktuellerProtokolleintrag !== undefined
                && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined)
        , map(([x, aktuellerProtokollEintrag, aktuelleVeranstaltung]) => {
            const request: FunkprotokollEintragRequest = {
                fall_id: aktuellerProtokollEintrag.fall_id,
                eintrag_id: aktuellerProtokollEintrag.eintrag_id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
            };
            return new PostFunkprotokollEintragEntfernenAction(request);
        })
    );

    @Effect()
    protokollEintragSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.ProtokollEintragSpeichern>(actionsUi.PROTOKOLL_EINTRAG_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollEintrag)),
            this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokolleintrag, aktuelleVeranstaltung]) => aktuellerProtokolleintrag !== null && aktuellerProtokolleintrag !== undefined
            && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined)
        , flatMap(([x, aktuellerProtokollEintrag, aktuelleVeranstaltung]) => {
            let id = this.uuid.generateUUID();
            if (aktuellerProtokollEintrag.eintrag_id !== undefined && aktuellerProtokollEintrag.eintrag_id !== null) {
                id = aktuellerProtokollEintrag.eintrag_id;
            }
            // console.log('Effect Eintrag speichern:', aktuellerProtokollEintrag);
            const request: FunkprotokollEintragRequest = {
                fall_id: aktuellerProtokollEintrag.fall_id,
                eintrag_id: id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
                melde_zeitpunkt_utc: aktuellerProtokollEintrag.melde_zeitpunkt_utc,
                melder: aktuellerProtokollEintrag.melder,
                meldeart_id: aktuellerProtokollEintrag.meldeart_id,
                text: aktuellerProtokollEintrag.text,
            };
            const actions: Array<Action> = [new PostFunkprotokollEintragErfassenAction(request)];
            if (x.neu) {
                actions.push(new actionsUi.NeuerProtokollEintrag());
            }
            return actions;
        })
    );

    @Effect()
    protokollFallUndEintragSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.ProtokollFallUndEintragSpeichern>(actionsUi.PROTOKOLL_FALL_UND_EINTRAG_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollFall)), this.store.pipe(select(getAktuellerProtokollEintrag)), this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokollFall, aktuellerProtokollEintrag, aktuelleVeranstaltung]) => aktuellerProtokollFall !== null && aktuellerProtokollFall !== undefined
            && aktuellerProtokollEintrag !== null && aktuellerProtokollEintrag !== undefined
            && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined)
        , flatMap(([x, aktuellerProtokollFall, aktuellerProtokollEintrag, aktuelleVeranstaltung]) => {

            const now = new Date();

            // Fall
            let fall_id = this.uuid.generateUUID();
            if (aktuellerProtokollFall.fall_id !== undefined && aktuellerProtokollFall.fall_id !== null) {
                fall_id = aktuellerProtokollFall.fall_id;
            }
            const fallRequest: FunkprotokollFallRequest = {
                fall_id: fall_id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
                titel: aktuellerProtokollFall.titel,
                erinnerung_in_minuten: aktuellerProtokollFall.erinnerung_in_minuten,
                erinnerung_zeitpunkt_utc: new Date(now.getTime() + aktuellerProtokollFall.erinnerung_in_minuten * 60000)
            };
            const actions: Array<Action> = [new PostFunkprotokollFallErfassenAction(fallRequest, {neuerFall: x.neuerFall, neuerEintrag: x.neuerEintrag})];

            // Eintrag
            let eintrag_id = this.uuid.generateUUID();
            if (aktuellerProtokollEintrag.eintrag_id !== undefined && aktuellerProtokollEintrag.eintrag_id !== null) {
                eintrag_id = aktuellerProtokollEintrag.eintrag_id;
            }
            // console.log('Effect Eintrag erfassen:', aktuellerProtokollEintrag);
            const eintragEequest: FunkprotokollEintragRequest = {
                fall_id: fall_id,
                eintrag_id: eintrag_id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
                melde_zeitpunkt_utc: aktuellerProtokollEintrag.melde_zeitpunkt_utc,
                melder: aktuellerProtokollEintrag.melder,
                meldeart_id: aktuellerProtokollEintrag.meldeart_id,
                text: aktuellerProtokollEintrag.text,
            };
            actions.push(new PostFunkprotokollEintragErfassenAction(eintragEequest, {neuerFall: x.neuerFall, neuerEintrag: x.neuerEintrag}));

            // if (x.neuerFall) {
            //     actions.push(new actionsUi.NeuerProtokollFall());
            // }
            // if (x.neuerEintrag) {
            //     actions.push(new actionsUi.NeuerProtokollEintrag());
            // }

            return actions;
        })
    );

    @Effect()
    protokollFallSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.ProtokollFallSpeichern>(actionsUi.PROTOKOLL_FALL_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollFall)), this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => aktuellerProtokollFall !== null && aktuellerProtokollFall !== undefined
            && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined)
        , flatMap(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => {
            const now = new Date();
            let id = this.uuid.generateUUID();
            if (aktuellerProtokollFall.fall_id !== undefined && aktuellerProtokollFall.fall_id !== null) {
                id = aktuellerProtokollFall.fall_id;
            }
            const request: FunkprotokollFallRequest = {
                fall_id: id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
                titel: aktuellerProtokollFall.titel,
                erinnerung_in_minuten: aktuellerProtokollFall.erinnerung_in_minuten,
                erinnerung_zeitpunkt_utc: new Date(now.getTime() + aktuellerProtokollFall.erinnerung_in_minuten * 60000)
            };
            const actions: Array<Action> = [new PostFunkprotokollFallErfassenAction(request)];
            if (x.neu) {
                actions.push(new actionsUi.NeuerProtokollEintrag());
            }
            return actions;
        })
    );

    @Effect()
    protokollFallAbschliessen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.ProtokollFallSpeichern>(actionsUi.PROTOKOLL_FALL_ABSCHLIESSENEN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollFall)), this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => aktuellerProtokollFall !== null && aktuellerProtokollFall !== undefined
            && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined)
        , flatMap(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => {
            let id = this.uuid.generateUUID();
            if (aktuellerProtokollFall.fall_id !== undefined && aktuellerProtokollFall.fall_id !== null) {
                id = aktuellerProtokollFall.fall_id;
            }
            const request: FunkprotokollFallRequest = {
                fall_id: id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
            };
            const actions: Array<Action> = [new PostFunkprotokollFallAbschliessenAction(request)];
            return actions;
        })
    );

    @Effect()
    protokollFallReaktivieren$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.ProtokollFallSpeichern>(actionsUi.PROTOKOLL_FALL_REAKTIVIEREN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollFall)), this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => aktuellerProtokollFall !== null && aktuellerProtokollFall !== undefined
            && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined)
        , flatMap(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => {
            const request: FunkprotokollFallRequest = {
                fall_id: aktuellerProtokollFall.fall_id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
            };
            const actions: Array<Action> = [new PostFunkprotokollFallReaktivierenAction(request)];
            return actions;
        })
    );

    @Effect()
    incidentErstellen$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.IncidentErstellenUiAction>(actionsUi.INCIDENT_ERSTELLEN)
        , withLatestFrom(this.store.pipe(select(getAktuellerProtokollFall)), this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , filter(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => aktuellerProtokollFall !== null && aktuellerProtokollFall !== undefined
            && aktuelleVeranstaltung !== null && aktuelleVeranstaltung !== undefined && true && true)
        , flatMap(([x, aktuellerProtokollFall, aktuelleVeranstaltung]) => {
            const id = this.uuid.generateUUID();
            const request: IncidentFunkprotokollRequest = {
                incident_id: id,
                fall_id: aktuellerProtokollFall.fall_id,
                veranstaltung_id: aktuelleVeranstaltung.veranstaltung_id,
            };
            const actions: Array<Action> = [new PostIncidentAnlegenAusFunkprotokollAction(request)];
            return actions;
        })
    );

    @Effect()
    protokollFallGewaehlt$: Observable<Action> = this.actions$.pipe(
        ofType<actionsUi.ProtokollFallAusgewaehlt>(actionsUi.PROTOKOLL_FALL_AUSGEWAEHLT)
        , withLatestFrom(this.store.pipe(select(getAusgewaehlteVeranstaltung)))
        , map(([x, aktuelleVeranstaltung]) => {
            return new GetIncidentByFunkprotokollFallAction(aktuelleVeranstaltung.veranstaltung_id, x.payload.fall_id);
        })
    );


    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private uuid: UuidService) {
    }
}
